import React, { useState, useEffect, useMemo, useCallback } from "react";
import PropTypes from "prop-types";
import { Avatar, Space } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { BaseCustomDropdownMenu } from "../../../shared";

// Redux
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

// Localization
import { withTranslation } from "react-i18next";

const ProfileDropdownMenu = ({ success, history }) => {
  const [username, setUsername] = useState("Admin");
  const [surname, setSurname] = useState("Admin");
  const [email, setEmail] = useState("Admin");
  const [role, setRole] = useState("Admin");

  useEffect(() => {
    const storedUser = localStorage.getItem("authUser");
    if (storedUser) {
      try {
        const authUser = JSON.parse(storedUser);

        if (authUser && typeof authUser === "object") {
          setUsername(authUser.username ?? authUser.name ?? "No name provided");
          setSurname(authUser.surname ?? "No surname provided");
          setEmail(authUser.email ?? "No email provided");
          setRole(authUser.role ?? "No role provided");
        } else {
          console.warn("Invalid authUser data. Redirecting to login.");
          localStorage.removeItem("authUser");
          history.push("/login"); // Redirect using history
        }
      } catch (error) {
        console.error("Error parsing authUser from localStorage:", error);
        localStorage.removeItem("authUser");
        history.push("/login");
      }
    } else {
      history.push("/login");
    }
  }, [success, history]);

  // Handle Logout
  const handleLogout = useCallback(() => {
    localStorage.removeItem("authUser");
    history.push("/login");
  }, [history]);

  // Memoize dropdown items to optimize rendering
  const dropdownItems = useMemo(
    () => [
      {
        key: "1",
        label: `Hola, ${username} ${surname}`,
        disabled: true,
        className: "text-secondary",
      },
      { type: "divider" },
      {
        key: "2",
        label: `Rol: ${role}`,
        disabled: true,
        className: "text-secondary",
      },
      {
        key: "3",
        label: `Email: ${email}`,
        disabled: true,
        className: "text-secondary",
      },
      { type: "divider" },
      {
        key: "log-out",
        label: (
          <button
            type="button"
            className="btn btn-link p-0 text-decoration-none border-0 w-100 text-start"
            onClick={handleLogout}
            style={{ color: "inherit", display: "inline-flex", alignItems: "center" }}
          >
            <i className="uil uil-sign-out-alt font-size-18 align-middle me-1 text-muted"></i>
            Cerrar Sesión
          </button>
        ),
      },
    ],
    [username, surname, role, email, handleLogout]
  );

  return (
    <div className="d-flex align-items-center justify-content-end">
      <BaseCustomDropdownMenu
        items={dropdownItems}
        toggleElement={
          <Space>
            <Avatar size="large" icon={<UserOutlined />} />
            <span className="fw-medium font-size-15">{username} {surname ? surname : ""}</span>
          </Space>
        }
        className="my-2"
        placement="bottomRight"
      />
      <div className="ps-2"></div>
    </div>
  );
};

ProfileDropdownMenu.propTypes = {
  success: PropTypes.any,
  history: PropTypes.object.isRequired, // Ensuring history is required
};

const mapStateToProps = (state) => ({
  success: state.Profile?.success,
});

export default withRouter(
  connect(mapStateToProps)(withTranslation()(ProfileDropdownMenu))
);